<template>
  <div>
    <p>
      Several constraints can be enforced for the target evasive maneuver
      design:
    </p>
    <ul>
      <li><b>Maximum ΔV</b> : the maximum maneuver impulse.</li>
      <li>
        <b>Minimum distance</b> : the minimum distance between chaser and
        target. If the distance is below this value, the evasive maneuver is not
        considered successful.
      </li>
      <li>
        <b>Maximum service loss duration</b> : the maximum service loss duration
        caused by an evasive maneuver to be performed before a detected
        conjunction. It denotes a lower limit for the date of maneuver in order
        not to lose the service for too long.
      </li>
      <li>
        <b>Minimum target reaction duration</b> : the minimum reaction duration
        to perform the target evasive maneuver. This maneuver will therefore be
        planned after this reaction duration.
      </li>
      <li>
        <b>Minimum chaser reaction duration</b> : the minimum reaction duration
        considered for the chaser reaction maneuver. From the date of the
        evasive maneuver, the chaser reaction maneuver will be planned after
        this duration.
      </li>
    </ul>
    <v-img
      contain
      :src="require('../../../assets/images/timeline-evasive.png')"
      aspect-ratio="1.5"
    />
  </div>
</template>

<script>
export default {
  name: 'tooltipEvasiveConstraints'
}
</script>
